import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { RichText } from 'prismic'

import Spacer from 'components/ui/Spacer'
import Image from 'components/ui/Image'
import ThemeWaypoint from 'components/ui/ThemeWaypoint'
import ParallaxImage from 'components/motion/ParallaxImage'
import { BodyCopy, Headline2 } from 'components/ui/Typography'

import s from './ImagesAndText.module.scss'
import HorizontalWapper from '../HorizontalWrapper'
const cn = classNames.bind(s)

const ImagesAndText = ({ data, themeWaypoint = 'light' }) => {
  const { primary } = data
  const justifyEnd = primary.aux_image && primary.heading && primary.content
  const hasPrimaryImage = primary.main_image
  const hasAuxImage = primary.aux_image
  const r = primary?.main_imageSharp?.childImageSharp?.fluid.aspectRatio || 0

  if (!primary) return null
  return (
    <HorizontalWapper>
      {!!themeWaypoint && <ThemeWaypoint after={themeWaypoint} />}
      <div className={cn('col', 'main', { hasImage: hasPrimaryImage })} style={{ '--r': r }}>
        {primary.main_image && (
          <div className={cn('image')}>
            {primary.main_imageSharp ? (
              <ParallaxImage
                image={primary.main_imageSharp}
                alt={(primary.heading && primary.heading[0].text) || 'main image'}
              />
            ) : (
              <Image src={primary.main_image.url} alt={(primary.heading && primary.heading[0].text) || 'main image'} />
            )}
          </div>
        )}
      </div>
      <Spacer initial="6rem" medium="11.11vh" horizontal />
      <div className={cn('col', 'aux', { hasImage: hasAuxImage, hasText: primary.heading || primary.content })}>
        <div className={cn('auxInner', { justifyEnd })}>
          {primary.aux_image && (
            <div className={cn('image')}>
              <div className={cn('imageInner')}>
                <Image
                  src={primary.aux_imageSharp ? primary.aux_image : primary.aux_image.url}
                  alt={primary.aux_image.alt || (primary.heading && primary.heading[0].text) || 'aux image'}
                />
              </div>
            </div>
          )}
          {primary.heading && (
            <div className={cn('heading')}>
              <Headline2>{primary.heading[0].text}</Headline2>
            </div>
          )}
          {primary.content && (
            <div className={cn('content')}>
              <BodyCopy as="div">{RichText.render(primary.content)}</BodyCopy>
            </div>
          )}
        </div>
      </div>
    </HorizontalWapper>
  )
}

ImagesAndText.propTypes = {
  data: PropTypes.object.isRequired,
  themeWaypoint: PropTypes.oneOf(['light', 'dark', null]),
}

// ImagesAndText.whyDidYouRender = true

export default ImagesAndText
